/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PbCcElementDto } from '@gh/builder-shared-data';
import { getRouteInitData, queryFormEditable, State } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { FocusedCell } from '@gh/core-ui-grid';
import { filter$, switchMap$ } from '@gh/rx/operators';
import { Observable } from 'rxjs';
import { PbCcStructure } from '../../../resources/price-book.model';
import { PbCommandService } from '../pb-command.service';
import {
  PbDetailsState,
  queryCostCenterStructures,
  querySelectedCostCenterId,
  querySelectedStructureId,
  queryStructureFocusedCell,
} from '../pb-details.state';
import { PbDetailsStructureGridDefinitionService } from './pb-details-structure-grid-definition.service';

@Component({
  selector: 'gh-pb-details-structure-list',
  template: require('./pb-details-structure-list.component.html'),
  styles: [require('./pb-details-structure-list.component.scss')],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [PbDetailsStructureGridDefinitionService],
})
export class PbDetailsStructureListComponent implements OnInit {
  selectedStructureId$: Observable<Maybe<ID>>;
  structures$: Observable<PbCcElementDto[]>;
  focusedCell$: Observable<Maybe<FocusedCell>>;
  editable: boolean = true;

  constructor(private route: ActivatedRoute,
              private state: State<PbDetailsState>,
              private commands: PbCommandService,
              public gridDefinition: PbDetailsStructureGridDefinitionService) {

  }

  ngOnInit(): void {
    const { priceBookItemsComponentsGridLayout } = getRouteInitData(this.route);

    this.gridDefinition.bind(priceBookItemsComponentsGridLayout);

    const costCenterId$ = this.state.select(querySelectedCostCenterId).pipe(filter$(Boolean));

    this.structures$ = costCenterId$.pipe(
      switchMap$((costCenterId: any) => this.state.select((state) => queryCostCenterStructures(state, costCenterId))));
    this.selectedStructureId$ = this.state.select(querySelectedStructureId);
    this.focusedCell$ = this.state.select(queryStructureFocusedCell);
    this.editable = queryFormEditable(this.state.value);
  }

  onAdd(): void {
    this.commands.structureAdd();
  }

  onDelete(structure: PbCcStructure): void {
    this.commands.structureRemove(structure);
  }

  onSelectedStructureChanged(id?: ID): void {
    this.commands.structureSelect(id);
  }

  onFocusedCellChanged(): void {
    this.commands.resetFocusedCell();
  }
}
